(() => {
  const performanceScript = document.currentScript;
  const mediaQuery = window.matchMedia('(max-width: 749px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const prepareHomeVideo = () => {
    const video = document.querySelector('.fkh2-hero-media video');
    if (!video) return;
    const source = video.querySelector('source');
    if (!source) return;

    const useMobileVideo = mediaQuery.matches;
    source.dataset.desktopSrc ||= source.src;
    const nextSource = useMobileVideo ? performanceScript?.dataset.mobileVideoSrc : source.dataset.desktopSrc;

    if (reducedMotionQuery.matches) {
      video.pause();
      video.preload = 'none';
      video.hidden = true;
      return;
    }

    if (nextSource && source.src !== nextSource) {
      source.src = nextSource;
      video.load();
    }

    video.hidden = false;
    video.preload = useMobileVideo ? 'metadata' : 'auto';
    video.play().catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareHomeVideo, { once: true });
  } else {
    prepareHomeVideo();
  }

  mediaQuery.addEventListener('change', prepareHomeVideo);
  reducedMotionQuery.addEventListener('change', prepareHomeVideo);
})();
